import { MenuItems } from '../auth/enums/menu-items.enum';

export interface AppRoute {
  path: string;
  name: MenuItems;
  iconName?: string;
  children?: AppRoute[];
  isCollapsingMenu?: boolean;
  redirectTo?: string;
}

export const APP_ROUTE_PATHS: Record<string, string> = {
  LOGIN: '/login',
  DASHBOARD: '/',

  GALLERY_MAIN_MENU: '/gallery',
  GALLERY: '/gallery/view',
  GALLERY_TAGS: '/gallery/picture-tags',
};

const AppRoutes: AppRoute[] = [
  {
    path: APP_ROUTE_PATHS.GALLERY_MAIN_MENU,
    name: MenuItems.GALLERY_MAIN_MENU,
    iconName: 'collections',
    isCollapsingMenu: true,
    children: [
      {
        path: APP_ROUTE_PATHS.GALLERY,
        name: MenuItems.GALLERY,
        iconName: 'apps',
      },
      {
        path: APP_ROUTE_PATHS.GALLERY_TAGS,
        name: MenuItems.GALLERY_TAGS,
        iconName: 'local_offer',
      },
    ],
  },
];

export default AppRoutes;
